<template>
  <div class="container">
    <div class="title">
      <a href="javascript:void(0);" class="back_btn" @click.prevent="closePage()">
        <img src="@/assets/images/close.svg" />
      </a>
      <span>Terms of Service</span>
      <img src="@/assets/images/logo_header.png" alt="Logo" class="logo" />
    </div>
    <div class="content">
      <p class="date">Effective Date: 02/19/2026</p>
      <p>
        Welcome to JoyJobs! We are building an accessible employment platform that helps individuals, including persons
        who may request reasonable accommodations, connect with job opportunities in industries like farming,
        hospitality, and retail, etc. These Terms of Service (the "Terms") constitute a legally binding agreement
        between you and JoyJobs.
      </p>
      <p>
        By accessing or using any part of JoyJobs' website, whether or not an account is created with JoyJobs, you agree
        to be bound by the Terms then in effect with the applicable contracting entity set forth below. If you do not
        agree, you may not access or use JoyJobs' website.
      </p>
      <p>
        The Terms hereby incorporate by reference any additional terms and conditions posted by JoyJobs. Unless
        otherwise indicated, the Terms apply to all users of the JoyJobs website. If you are accessing or using the
        JoyJobs' website in your capacity as an employee or other representative of an Employer, you agree to the Terms
        on behalf of yourself and such employer, and you represent and warrant that you have the authority to bind such
        Employer to the Terms.
      </p>
      <p>
        JoyJobs may reject, remove, or limit the visibility of any user content, and JoyJobs may disable any account or
        restrict your ability to use all or part of its website, for any or no reason without notice. JoyJobs reserves
        the right to make such decisions in our interest or our users' interest.
      </p>
      <p>
        JoyJobs is a technology platform that helps Job Seekers connect with employers. JoyJobs does not and will not
        serve as an agent of, or decision-maker for, any Employer or any Job Seeker throughout these Terms.
      </p>
      <p>
        For more information on how JoyJobs processes your personal data, please visit our Privacy Policy. By accessing
        or using the JoyJobs website, you also represent that you have read and understand the Terms as well as the
        Cookie Policy and Privacy Policy.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">Definitions</p>
      <ul class="content_ul">
        <li>
          <span style="font-weight: bold;">AI Tools:</span> AI Tools provided by third parties are used by the JohJobs
          for the purposes of supporting the users' creations of their contexts on this platform.
        </li>
        <li>
          <span style="font-weight: bold;">AI-Generated Content:</span> Content created in whole or in part by an
          algorithm, including artificial intelligence and machine learning models, which may be generated in response
          to information you provide.
        </li>
        <li>
          <span style="font-weight: bold;">Employer:</span> An individual or organization using the JoyJobs website to
          seek Job Seekers, or otherwise obtain information related to hiring or human resources, on their own behalf or
          another's.
        </li>
        <li>
          <span style="font-weight: bold;">Job Seeker:</span> An individual preparing, searching and applying for
          employment openings, or using or accessing services or information or posting information on the JoyJobs'
          website related to their personal employment or job search.
        </li>
        <li>
          <span style="font-weight: bold;">Personal Data:</span> Any information that relates to an identified or
          identifiable natural person. An identifiable natural person is one who can be identified, directly or
          indirectly, in particular by reference to an identifier such as a name, an identification number, location
          data, an online identifier or to one or more factors specific to the physical, physiological, genetic, mental,
          economic, cultural or social identity of that natural person.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">1. JoyJobs'Service</p>
      <ul class="content_ul">
        <li>
          For Job Seekers: <br />
          Create and manage a profile;<br />
          Browse and apply to job listings;<br />
          Message with Employers;<br />
          Save job preferences.<br /><br />
        </li>
        <li>
          For Employers:<br />
          Create and verify an individual or company account;<br />
          View and seek published Job Seekers' profiles.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">2. Terms for Job Seekers</p>
      <ul class="content_ul">
        <li>
          Job Seekers must be individuals at least sixteen (16) years old.
        </li>
        <li>
          A Job Seeker can only create one account with the JoyJobs' website.
        </li>
        <li>
          Job Seekers are permitted to use JoyJobs website and its content for your personal, non-commercial purpose of
          seeking employment or information related to your job search. You agree that your license to use the JoyJobs'
          website is automatically revoked upon your attempt to use the JoyJobs' website for any other purpose.
        </li>
        <li>
          By creating or adding information to a profile through the JoyJobs' website, you authorize JoyJobs' to make it
          available to potential Employers. However, Job Seekers are solely responsible for the accuracy of their
          information provided on the JoyJobs' website.
        </li>
        <li>
          You understand and agree that JoyJobs has no obligation to screen or include any job opportunities in its
          search results or other listings, and may exclude or remove any employment information from its website or
          your search result without any obligation to provide reasoning for removal or exclusion.
        </li>
        <li>
          JoyJobs offers tools to help you find job opportunities. Such tools are created by JoyJobs and may not
          perfectly reflect job and content.
        </li>
        <li>
          JoyJobs does not guarantee that your application will be delivered, received, or acted upon, or that you will
          receive a response or an interview.
        </li>
        <li>
          When you apply to a job or otherwise interact with an Employer through the JoyJobs' website, you agree and
          understand that only the Employer, and not JoyJobs, makes any decision in the recruitment and hiring process.
        </li>
        <li>
          JoyJobs does not guarantee the identity of an Employer or any individuals working for any Employers, and
          cautions Job Seekers when applying to jobs. JoyJobs cannot make any guarantee regarding health and safety
          measures in an Employer's hiring or interviewing process. Job Seekers are solely responsible for verifying the
          accuracy or legitimacy of any Employer or job offer.
        </li>
        <li>
          JoyJobs has no control over third-party job opportunities, their content, or any conditions after a Job Seeker
          applies or leaves the JoyJobs' website. By leaving JoyJobs' website for a third-party site, you accept their
          terms.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">3. Terms for Employers</p>
      <ul class="content_ul">
        <li>
          An Employer must create only one account with the JoyJobs' website for its one hiring session. An Employer may
          maintain multiple JoyJobs' accounts by its different departments or for its multiple sessions of hiring needs.
        </li>
        <li>
          Employers must verify their identities by and through one of the following: <br />
          1.A matching work email domain;<br />
          2.A valid business license; <br />
          3.Manual approved by the JoyJobs' team.
        </li>
        <p>
          You acknowledge and agree that the above-mentioned verification shall not eliminate your obligation to ensure
          the accuracy of information that you provide on the JoyJobs' website.
        </p>
        <li>
          Employers are solely responsible for your account, your use of the JoyJobs' website and any tools offered
          therein, your decisions regarding job descriptions, job requirements, any and all content of your employment,
          whom you interview or hire, and compliance with applicable laws.
        </li>
        <li>
          Employers' accounts are for business use and not for personal use. You agree that your license to use the
          JoyJobs' website is automatically revoked upon your attempt to use the website for any other purposes other
          than make information available regarding employment, seek Job Seekers, or otherwise obtain information
          related to hiring or human resources.
        </li>
        <li>
          Employers are prohibited from using or relying on the JoyJobs website in place of their own independent
          judgment and decision-making at any step in the recruitment or hiring processes. Employers are responsible for
          providing any necessary accommodations to Job Seekers as required by law.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">4. General Terms</p>
      <ul class="content_ul">
        <li>
          Neither any user nor JoyJobs may appoint, assign, delegate, accept, or otherwise attempt to confer any agency,
          authority, fiduciary role, or decision-making power on the other. Neither party may seek or agree to act as
          the other's agent, representative, or decision-maker, and neither may represent or imply to any third party
          that any such relationship exists. Each party remains solely responsible for its own decisions, actions, and
          outcomes, and must exercise its own independent judgment when using or providing the JoyJobs' website.
        </li>
        <li>
          The JoyJobs' website may be unavailable or malfunction without notice. To the extent permitted by law, JoyJobs
          disclaims any and all responsibility or liability for the accuracy, content, completeness, legality,
          reliability, operability, or availability of information on or linked from the JoyJobs' website, whether paid
          or free. JoyJobs is not responsible for deletion, storage failure, mis-delivery, or untimely delivery of any
          information, messages, or material. JoyJobs does not guarantee the website will be error-free, safe, or
          secure, and disclaims responsibility for harm from downloading or accessing information on the website or
          linked third-party sites. Under no circumstances is JoyJobs' liable for your use or misuse of, or reliance on,
          the website or any linked third-party sites or services. JoyJobs further disclaims all liability for technical
          malfunctions of the website. This includes injury or damage to your or others' person, computer, mobile
          device, or hardware/software related to using JoyJobs' service.
        </li>
        <li>
          JoyJobs reserves the right to limit or terminate its services and website access due to war, political,
          uncertainty, epidemic, pandemic, riot, national/regional emergency, terrorism, or civil disorder. JoyJobs is
          not liable for delays or failures caused by circumstances beyond its control, including: (a) acts of
          God/natural catastrophes; (b) flood, fire, storm, earthquake, epidemics/pandemics, explosion; (c) war,
          invasion, hostilities, terrorist threats/acts, riots, insurrections, civil unrest, military disturbances,
          sabotage; (d) government action/orders; (e) embargoes/blockades; (f) governmental authority action; (g)
          national/regional emergency; (h) strikes, labor disputes/slowdowns, industrial disturbances, labor/material
          shortages; (i) utility, communications, computer, or telephone communication service failures/malfunctions;
          (j) internet, computer, telecommunication equipment, electrical power, or other equipment/mechanical
          failures/shortages; (k) data loss due to power failures or storage system difficulties; (l) non-performance of
          third parties; and (m) other events beyond JoyJobs' control.
        </li>
        <li>
          JoyJobs may collect information about any users and their actions taken on the JoyJobs' website using
          automated means, like cookies. Although the Terms require any Employer using tracker functionality on the
          JoyJobs' website must provide notice and obtain consent as required by applicable law, you acknowledge and
          agree that JoyJobs has no control over such an Employer, its website, etc. You agree to JoyJobs' use of, and
          receipt of information from, any such tracker functionality. JoyJobs' use and receipt of information from such
          trackers will comply with the Terms and JoyJobs' Privacy Policy.
        </li>
        <li>
          JoyJobs reserves the right to disclose users' content, account information, or any other relevant information
          to third parties in connection with operating the website, to protect itself or others, or to comply with
          legal obligations or requests like subpoenas, court orders, or warrants. Your identity may be discoverable via
          such legal requests, even if you post confidentially or anonymously.
        </li>
        <li>
          THIS SITE AND ALL CONTENT, FEATURES, AND SERVICES ARE PROVIDED "AS IS" WITH NO WARRANTIES OF ANY KIND, EXPRESS
          OR IMPLIED. TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOU USE THE WEBSITE AT YOUR OWN RISK.
        </li>
        <li>
          JOYJOBS HAS NO RESPONSIBILITY FOR CONFIRMING A USER'S IDENTITY. USER ACTIVITY SUCH AS CLICK, STARTED
          APPLICATION, OR APPLICATION IS NOT A GUARANTEE OF INTEREST IN YOUR JOB SEEKING. JOYJOBS IS NOT RESPONSIBLE FOR
          CLICK FRAUD, FRAUDULENT LEADS, TECHNOLOGICAL ISSUES, OR OTHER POTENTICAL INVALID ACTIVITY BY THIRD PARTIES.
        </li>
        <li>
          TO THE EXTENT PERMITTED BY LAW, UNDER NO CIRCUMSTANCES SHALL JOYJOBS, ITS EMPLOYEES, OR REPRESENTATIVES, BE
          LIABLE TO ANY PERSON ON ACCOUNT OF THAT PERSON'S USE OR MISUSE OF OR RELIANCE ON THE WEBSITE. SUCH LIMITATION
          OF LIABILITY SHALL APPLY TO PREVENT RECOVERY OF INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, AND
          PUNITIVE DAMAGES OR ANY LOSS OF PROFITS, REVENUE, INTEREST, GOODWILL, LOSS OR CORRUPTION OF DATA OR ANY LOSS
          OF OR INTERRUPTION TO THE PERSON'S BUSINESS, WHETHER SUCH CLAIM IS BASED ON WARRANTY, CONTRACT, TORT
          (INCLUDING NEGLIGENCE), INDEMNITY, OR OTHERWISE, EVEN IF JOYJOBS, ITS EMPLOYEES, OR REPRESENTATIVES, HAVE BEEN
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY
          REMEDY. TO THE EXTENT PERMITTED BY LAW, THE MAXIMUM AGGREGATE LIABILITY OF JOYJOBS, ITS EMPLOYEES, AND
          REPRESENTATIVES, FOR ALL DAMAGES, LOSSES AND CAUSES OF ACTION, WHETHER IN CONTRACT, TORT (INCLUDING
          NEGLIGENCE) OR OTHERWISE, SHALL BE LIMITED TO THE AMOUNTS PAID AND OR PAYABLE BY YOU IN THE PRECEDING SIX (6)
          MONTHS PRIOR TO THE INCIDENT GIVING RISE TO THE CLAIM.
        </li>
        <li>
          All users agree to indemnify, defend, and hold harmless JoyJobs, its employees, officers, directors, and
          representatives from any and all losses, claims, damages, actions, suits, demands, judgments, settlements,
          liabilities, and costs and expenses (including attorneys' fees and costs) arising out of or related to (a)
          your breach of the Terms; (b) your access to, use of, or misuse of the website; (c) any information or data
          you provide; (d) your violation of any applicable law or the rights of any third party; (e) your use of
          tacking technology; (f) your loss of, or disclosure of, information gained from using this website; (g)
          Employers' actions and processes; and (h) your use of a third party services or the activities of any third
          party you engage to assist you with activities related to your use of the website. This paragraph survives the
          termination of the Terms and your use of the website or any JoyJobs service.
        </li>
        <li>
          JoyJobs is a technology platform and has no obligation to host, publish, monitor, or remove any particular
          user's content. JoyJobs may, in its sole discretion, reject, remove, or limit the visibility of any user's
          content for any or no reason without notice. JoyJobs reserves the right to make such decisions in our interest
          or our users' interest. You agree that JoyJobs has no liability or obligation to you or anyone else arising
          from its decisions with respect to users' content.
        </li>
        <li>
          JoyJobs is not responsible for users' content, which may be inaccurate, incomplete, misleading, deceptive, or
          offensive. Users' content is the sole responsibility of its original author.
        </li>
        <li>
          JoyJobs may monitor and screen users' content for compliance with its Terms and policies, to prevent potential
          illegal or harmful activities, or to prevent other activities that may be detrimental to other users. You
          acknowledge and agree that JoyJobs' detection methods are not perfect and false positives or false negatives
          may occur.
        </li>
        <li>
          If you believe any user's content violates the Terms, you may contact JoyJobs. JoyJobs has the authority but
          not obligation to respond and/or remove such reported user's content at its sole discretion.
        </li>
        <li>
          You acknowledge that JoyJobs owns all proprietary rights, title and interest in the website, including in
          compilations of information available through the website. JoyJobs reserves all rights not expressly granted
          herein. When you provide users' content, you grant JoyJobs a nonexclusive, worldwide, perpetual, fully paid,
          royalty-free, transferable, and sublicensable right and license to make, use, sell, sublicense, reformat,
          reproduce, distribute, perform, display, prepare derivative works from and otherwise exploit your users'
          content for the purpose of publishing material on the JoyJobs' website, maintaining or improving the JoyJobs'
          website, and promoting JoyJobs' website without restriction. To the extent permitted by law, no compensation
          in any form shall be due or payable to you in connection with JoyJobs' exercise of these rights. You represent
          and warrant that you own your user content or have the right to grant this license, and that its use by
          JoyJobs will not violate any law or infringe on the rights of any third party or result in any breach of
          contract between you and any third party.
        </li>
        <li>
          JoyJobs provides messaging services that facilitate contact between Employers and Job Seekers regarding
          employment opportunities. You may use such messages for the limited purpose of discussing or responding to
          employment opportunities. JoyJobs does not guarantee delivery, receipt, access, or action on communications,
          nor do we guarantee error-free integration with third-party providers on whom these services rely.
        </li>
        <li>
          JoyJobs may provide or permit AI-Generated content on the website. AI-Generated content may be generated in
          whole or in part by third-party service providers. JoyJobs makes no warranty that AI-Generated content is
          appropriate, accurate, inoffensive, unbiased, non-infringing, legal, or safe, and disclaims all liability for
          AI-Generated content. You are solely responsible for evaluating the accuracy and appropriateness of any
          AI-Generated content before using it. You agree that you do not have any intellectual property rights in any
          AI-generated content, to the extent permitted by law.
        </li>
        <li>
          You may terminate your agreement to the Terms, subject to any surviving obligations described in these Terms,
          at any time by closing your account and ceasing to use the website. JoyJobs may, at its sole discretion,
          suspend or terminate your account, remove your content, or restrict, suspend or terminate your access to any
          part of the website, at any time, for any or no reason, without prior notice or liability. Reasons for such
          action may include a violation of the Terms, actions that harm JoyJobs or its users or third-parties,
          violation of applicable law, or for business convenience. JoyJobs is not obligated to provide a reason for
          termination.
        </li>
        <li>
          Any provisions of the Terms that by their nature should survive termination will survive termination,
          including but not limited to, indemnification, limitation of liability, disclaimers of warranties, IP rights,
          etc.
        </li>
      </ul>
      <a-divider class="content_divider" />
      <p class="sub_title">5. Arbitration Agreement</p>
      <p>
        You and JoyJobs agree that any disagreement, controversy, claim, or legal proceeding or petition of any kind,
        whether based in contract, tort, statute, regulation, equity, or any other legal or equitable theory, arising
        out of or relating in any way the Terms, this website, or your interactions with it, between you and JoyJobs or
        between you and any other user, will be resolved by binding arbitration, rather than in court, to the extent
        permitted by law, except you or JoyJobs may asset claims in small claims court if such claims qualify and remain
        in small claims court.
      </p>
      <p>
        The Federal Arbitration Act ("FAA"), 9 U.S.C. §1 et seq., shall govern the interpretation and enforcement of
        this arbitration agreement. The laws of the State of Washington shall govern all other aspects, including
        substantive rights and obligations, to the extent consistent with the FAA.
      </p>
      <p>
        The arbitration, including any in-person arbitration hearing, will be conducted in the County of King, the State
        of Washington, where JoyJobs domiciled. The arbitrator will be either a retired judge or an attorney in good
        standing from the AAA's roster of arbitrators.
      </p>
      <p>
        The parties shall bear their own attorneys' fees and costs in arbitration unless otherwise required by
        applicable law or unless the arbitrator finds otherwise.
      </p>
      <p>
        PLEASE BE AWARE THIS SECTION PROVIDES AN ARBITRATION AGREEMENT THAT APPLIES TO ALL USERS LOCATED IN THE UNITED
        STATES. PLEASE READ CAREFULLY.
      </p>
      <p>
        THIS ARBITRATION AGREEMENT PROVIDES THAT YOU AND JOYJOBS: (1) WILL ONLY BE PERMITTED TO PURSUE DISPUTES AGAINST
        EACH OTHER OR OTHER USERS THROUGH BINDING, FINAL ARBITRATION; (2) WAIVE ALL RIGHTS TO BRING OR PARTICIPATE IN A
        DISPUTE ON A CLASS, COLLECTIVE, OR REPRESENTATIVE BASIS, TO THE EXTENT PERMITTED BY LAWS; AND (3) WAIVE ALL
        RIGHTS TO PURSE DISPUTS IN A COURT OF LAW, TO HAVE A JURU TRAIL AND/OR A CLASS ACTION.
      </p>
      <p>
        Notwithstanding anything to the contrary, JoyJobs is committed to working with you to reach a prompt and
        mutually beneficial resolution without need for arbitration. You and JoyJobs agree to participate in good faith
        informal efforts to resolve disputes before initiating any arbitration.
      </p>
      <a-divider class="content_divider" />
      <p class="sub_title">6. Miscellaneous</p>
      <p>
        Unless otherwise indicated in the Terms, notices to JoyJobs must be sent via certified mail to the appropriate
        entity address listed on the website; Notices to you under these Terms will be delivered by and through your
        email address included in your contact information that was provided by you at the time of creation your
        JoyJobs' account.
      </p>
      <p>
        If any term or provision of these Terms is invalid, illegal, or unenforceable in any jurisdiction, such
        invalidity, illegality, or unenforceability shall not affect any other term or provision of these Terms or
        invalidate or render unenforceable such term or provision in any other jurisdiction. Upon such determination
        that any term or other provision is invalid, illegal, or unenforceable, the parties hereto shall negotiate in
        good faith to modify this Terms so as to effect the original intent of the parties as closely as possible in a
        mutually acceptable manner in order that the transactions contemplated hereby be consummated as originally
        contemplated to the greatest extent possible.
      </p>
      <p>
        JoyJobs may update these Terms from time to time. If JoyJobs makes any future material modification to these
        Terms, JoyJobs will notify you by email or showing a notification at the time you access the website. Your
        access to or use of the website following any such changes to the Terms will constitute your affirmative
        acceptance of such changes.
      </p>
      <a-divider class="content_divider" />
      <p>Questions? Feedback? Reach us at: <a class="contact_email">hello@joylanders.com</a></p>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();
const closePage = () => {
  // window.close() 只能关闭 window.open 打开的窗口，直接从首页进入时会被浏览器静默拦截
  // 优先返回上一页，没有历史记录则跳首页
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/index');
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 850px;
  padding: 50px;
  margin: 50px auto;
  .back_btn {
    position: absolute;
    left: 20px;
    top: 10px;
  }
  .title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #05644f;
    .logo {
      float: right;
      width: 230px;
      height: auto;
    }
  }
  .content {
    font-size: 14px;
    line-height: 24px;
    color: #3d3d3d;
    .date {
      font-size: 14px;
      color: #05644f;
      margin-bottom: 20px;
    }
    .sub_title {
      font-size: 24px;
      font-weight: 500;
      margin-top: 20px;
    }
    .content_divider {
      margin: 30px 0;
      background: #fff;
    }
    a {
      color: #0256ff;
      text-decoration: none;
    }
    .label {
      font-weight: 700;
    }
    .circle {
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #3d3d3d;
      border-radius: 50%;
      margin-right: 8px;
      vertical-align: middle;
    }
    .content_ul {
      padding-left: 20px;
      li {
        margin-bottom: 10px;
      }
    }
    .contact_email {
      color: #3d3d3d;
      font-weight: bold;
    }
  }
  // 手机端适配（≤640px）：固定 850px 容器在手机上横向溢出，logo 与关闭按钮跑出屏幕
  @media (max-width: 640px) {
    position: relative;
    box-sizing: border-box;
    width: auto;
    padding: 56px 16px 32px;
    margin: 0 auto;
    .back_btn {
      position: absolute;
      left: 12px;
      top: 14px;
      img {
        width: 20px;
        height: 20px;
      }
    }
    .title {
      font-size: 20px;
      margin-bottom: 16px;
      .logo {
        width: 120px;
      }
    }
    .content {
      font-size: 13px;
      line-height: 21px;
      word-break: break-word;
      .date {
        margin-bottom: 14px;
      }
      .sub_title {
        font-size: 18px;
        margin-top: 16px;
      }
      .content_divider {
        margin: 20px 0;
      }
      .content_ul {
        padding-left: 18px;
      }
    }
  }
}
</style>
